export default __webpack_public_path__ + "static/media/vampireclose.9cede7b5.mp3";